import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../shapes/Line'
import { Paragraph } from '../presentation/Text'
import FlexGrid, { FlexCol } from '../structure/FlexGrid'
import Icon from '../shapes/Icon'
import IconText from '../presentation/IconText'
import Link from '../actions/Link'
import Separator from './Separator'
import SeparatorWrapper from './SeparatorWrapper'
import Tooltip from './Tooltip'

export const InfoIconTooltipLink = ({ label, icon, ...props }) => (
  <FlexCol>
    <Link {...props}>
      <IconText
        transparent
        iconName={icon || 'BsQuestionCircle'}
        left
        color={COLORS.lightGreen}
        label={label}
        iconSize=".8rem"
        size="small"
      />
    </Link>
  </FlexCol>
)

export const InfoIconTooltip = ({ maxWidth, text, label, links, children, ...props }) => {
  return (
    <Tooltip
      maxWidth={maxWidth || '24rem'}
      actionContent={
        <div {...props}>
          <Icon name="BsInfoCircle" color={COLORS.dark3} size=".9rem" {...props} />
        </div>
      }
      noPadding
      bgColor={COLORS.dark1}
    >
      <SeparatorWrapper weight={3} usePadding>
        {children}
        <Paragraph size="small" color={COLORS.white} hideIfNull>
          {text || label}
        </Paragraph>

        {!!links && !!links.length && (
          <>
            <Separator weight={2} />
            <HorizontalLine lineColor={COLORS.dark3} thin={1} />
            <Separator weight={4} />

            <FlexGrid gutter={0.3} direction="column" align="flex-start">
              {links.map(link => (
                <InfoIconTooltipLink key={link.label} {...link} />
              ))}
            </FlexGrid>
          </>
        )}
      </SeparatorWrapper>
    </Tooltip>
  )
}
